﻿import React, { useState, useEffect } from 'react';
import MobilePhaseComponent from './MobilePhaseComponent';
import MethodColumnComponent from './MethodColumnComponent';
import MobilePhaseEditor from './MobilePhaseEditor';
import ItemBasicInformationDialog from '../ItemBasicInformationDialog';
import { MethodDetail } from '../../models/Methods/method-detail';
import { LookupItem } from '../../models/lookup-item';
import { CrudFunctions } from '../../utilities/crud-functions';
import { Method } from '../../models/Methods/method';
import { Gradient } from '../../models/Methods/gradient';
import { FieldUpdate } from '../../models/field-update';
import SolventsLookup from '../Solvents/SolventsLookup';
import { SolventConfiguration } from '../../models/Solvents/solvent-configuration';
import { ItemBasicInformation } from '../../models/item-basic-information';
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { BenchSheetTechnologyType, ModalMessageType } from '../../models/enums';
import { ToastProps } from '../../models/toast-props';

import DataGrid, {
    Column,
    Selection,
    Button as ColumnButton,
    Toolbar,
    Item as ToolbarItem,
    Editing,
    Paging,
    LoadPanel
} from 'devextreme-react/data-grid';

import {
    Validator,
    StringLengthRule
} from 'devextreme-react/validator';

import TextBox from 'devextreme-react/text-box';
import SelectBox from 'devextreme-react/select-box';
import NumberBox from 'devextreme-react/number-box';
import Button from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import { Toast } from 'devextreme-react/toast';

let key = 0;

export interface Props {
    methodId: string;
    selectedMethod?: Method;
    readOnly: boolean;
}

export default function HplcMethodDetailsComponent(props: Props) {
    const [methodDetail, setMethodDetail] =
        useState<MethodDetail>();

    const [selectedGradient, setSelectedGradient] =
        useState<Gradient>();

    const [scanTypes, setScanTypes] =
        useState<LookupItem[]>();

    const [solventLookupVisible, setSolventLookupVisible] =
        useState<boolean>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [dataLoaded, setDataLoaded] =
        useState<boolean>(false);

    useEffect(() => {
        getAllData();
    }, []);

    useEffect(() => {
        getMethodDetails();
    }, [props.methodId]);

    //this is needed, otherwise Description gets overwritten by the previous value 
    useEffect(() => {
        setDataLoaded(true);
    }, [methodDetail]);

    key++;

    const mobilePhaseA = methodDetail && methodDetail.mobilePhases && methodDetail.mobilePhases.find(mp => mp.mobilePhaseType === 1);
    const mobilePhaseB = methodDetail && methodDetail.mobilePhases && methodDetail.mobilePhases.find(mp => mp.mobilePhaseType === 2);
    const mobilePhaseC = methodDetail && methodDetail.mobilePhases && methodDetail.mobilePhases.find(mp => mp.mobilePhaseType === 3);
    const mobilePhaseD = methodDetail && methodDetail.mobilePhases && methodDetail.mobilePhases.find(mp => mp.mobilePhaseType === 4);
    const mobilePhaseE = methodDetail && methodDetail.mobilePhases && methodDetail.mobilePhases.find(mp => mp.mobilePhaseType === 5);

    return (
        <div className="dma-bg-light-blue pw-padding-05 pw-margin-top-1" >
            <div>
                <div className="pw-comp-row">
                    <div className="pw-form-unit pw-comp-15">
                        <div className="pw-form-unit-label">Solvent Name</div>
                        <TextBox id="solventName" className="textbox" readOnly={true}
                            disabled={props.readOnly}
                            placeholder="NA"
                            value={methodDetail && methodDetail.solventName ? methodDetail.solventName : undefined} />
                    </div>

                    <div className="pw-row-button-08">
                        <Button className="title-bar-button"
                            text="" icon="search" type="success"
                            hint="lookup solvent"
                            onClick={showSolventsLookupDialog} />
                    </div>
                </div>

                <div className="pw-comp-row">
                    <div className="pw-form-unit pw-comp-15">
                        <div className="pw-form-unit-label">Detectors</div>
                        <TextBox id="detectors" className="textbox"
                            onValueChanged={onValueChanged} disabled={props.readOnly}
                            showClearButton={true} placeholder="NA"
                            value={methodDetail && methodDetail.detectors ? methodDetail.detectors : undefined} />
                    </div>
                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">Wavelength</div>
                        <NumberBox id="wavelength" className="textbox"
                            onValueChanged={onValueChanged} disabled={props.readOnly}
                            showClearButton={true} placeholder="NA"
                            value={methodDetail && methodDetail.wavelength ? methodDetail.wavelength : undefined} />
                    </div>
                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">Injection Volume</div>
                        <NumberBox id="injectionVolume" className="textbox"
                            onValueChanged={onValueChanged} disabled={props.readOnly}
                            showClearButton={true} placeholder="NA"
                            value={methodDetail && methodDetail.injectionVolume ? methodDetail.injectionVolume : undefined} />
                    </div>
                </div>

                <div className="pw-comp-row">
                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">Detector Temp.</div>
                        <NumberBox id="detectorTemperature" className="textbox"
                            onValueChanged={onValueChanged} disabled={props.readOnly}
                            showClearButton={true} placeholder="NA"
                            value={methodDetail && methodDetail.detectorTemperature ? methodDetail.detectorTemperature : undefined} />
                    </div>
                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">Column Temperature</div>
                        <NumberBox id="columnTemperature" className="textbox"
                            onValueChanged={onValueChanged} disabled={props.readOnly}
                            showClearButton={true} placeholder="NA"
                            value={methodDetail && methodDetail.columnTemperature ? methodDetail.columnTemperature : undefined} />
                    </div>
                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">Flow Rate</div>
                        <NumberBox id="flowRate" className="textbox"
                            onValueChanged={onValueChanged} disabled={props.readOnly}
                            showClearButton={true} placeholder="NA"
                            value={methodDetail && methodDetail.flowRate ? methodDetail.flowRate : undefined} />

                    </div>
                </div>

                <div className="pw-form-unit">
                    <div className="pw-form-unit-label">Traceability</div>
                    <TextBox id="traceability" className="textbox"
                        readOnly={props.readOnly} placeholder='NA'
                        onValueChanged={onValueChanged}
                        value={methodDetail && methodDetail.traceability ? methodDetail.traceability : undefined}>
                        <Validator>
                            <StringLengthRule message="Part Number must be less than 100 characters in length." max={100} />
                        </Validator>
                    </TextBox>
                </div>
            </div>

            {/*
            <div className="lq-sub-title pw-margin-left-05 pw-margin-top-1 pw-margin-bottom-05">Mobile Phases</div>
            */}

            <div className="pw-comp-row">
                <MobilePhaseEditor methodId={props.methodId} readOnly={props.readOnly} />


                {/*
                {mobilePhaseA &&
                    <div className="pw-comp-15">
                        <MobilePhaseComponent mobilePhase={mobilePhaseA}
                            mobilePhaseType='A' methodId={methodDetail && methodDetail.methodId ? methodDetail.methodId : undefined} />
                    </div>
                }

                {mobilePhaseB &&
                    <div className="pw-comp-15">
                        <MobilePhaseComponent mobilePhase={mobilePhaseB}
                            mobilePhaseType='B' methodId={methodDetail && methodDetail.methodId ? methodDetail.methodId : undefined} />
                    </div>
                }

                {mobilePhaseC &&
                    <div className="pw-comp-15">
                        <MobilePhaseComponent mobilePhase={mobilePhaseC}
                            mobilePhaseType='C' methodId={methodDetail && methodDetail.methodId ? methodDetail.methodId : undefined} />
                    </div>
                }

                {mobilePhaseD &&
                    <div className="pw-comp-15">
                        <MobilePhaseComponent mobilePhase={mobilePhaseD}
                            mobilePhaseType='D' methodId={methodDetail && methodDetail.methodId ? methodDetail.methodId : undefined} />
                    </div>
                }

                {mobilePhaseE &&
                    <div className="pw-comp-15">
                        <MobilePhaseComponent mobilePhase={mobilePhaseE}
                            mobilePhaseType='E' methodId={methodDetail && methodDetail.methodId ? methodDetail.methodId : undefined} />
                    </div>
                }
                */}
            </div>

            <div className="pw-form-unit pw-margin-top-1">
                <DataGrid height="16rem"
                    keyExpr="gradientId"
                    dataSource={methodDetail && methodDetail.gradients ?
                        methodDetail.gradients : []}
                    onSelectionChanged={gradientSelectionChanged}
                    allowColumnResizing={true}
                    columnResizingMode='widget'
                    showBorders={true}
                    wordWrapEnabled={true}
                    onRowValidating={onGradientsValidating}
                    onRowRemoving={onGradientsRowRemoving}
                    showRowLines={true}
                    rowAlternationEnabled={true} >

                    <Paging enabled={false} />
                    <LoadPanel enabled={true} />
                    <Selection mode='single' />

                    <Column name="bc0" type="buttons" width='6rem'>
                        <ColumnButton hint="information" icon="info"
                            onClick={onGradientsInfoButtonClick} />
                        <ColumnButton name="edit" />
                        <ColumnButton name="save" />
                        <ColumnButton name="delete" />
                    </Column>

                    <Column dataField='time' dataType="number" width='20%' />
                    <Column dataField='a' caption="A" dataType="number" width='20%' />
                    <Column dataField='b' caption="B" dataType="number" width='20%' />
                    <Column dataField='c' caption="C" dataType="number" width='20%' />
                    <Column dataField='d' caption="D" dataType="number" width='20%' />

                    <Column />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Gradients</div>
                            </div>
                        </ToolbarItem>

                        {!props.readOnly &&
                            <ToolbarItem location='after' name="addRowButton" />
                        }

                    </Toolbar>

                    {!props.readOnly &&
                        <Editing mode="row"
                            useIcons={true}
                            allowAdding={true}
                            allowUpdating={true}
                            allowDeleting={true}
                            newRowPosition="last" />
                    }
                </DataGrid>
            </div>

            <div className="pw-form-unit pw-margin-top-1 pw-padding-bottom-05">
                <MethodColumnComponent methodId={props.methodId}
                    technologyId={BenchSheetTechnologyType.HighPerformanceLiquidChromatography}
                    readOnly={props.readOnly} />
            </div>

            {solventLookupVisible &&
                <DialogPopup visible={solventLookupVisible}
                    onHiding={hideSolventsLookupDialog}
                    title="Solvent Lookup"
                    width='50vw'
                    height='50vh'
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <SolventsLookup onApplySelection={onSolventsLookupApplySelection}
                        onCancel={hideSolventsLookupDialog}
                        key={`SL${key}`} />
                </DialogPopup>
            }

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {toastProps && toastProps.visible &&
                <Toast
                    visible={toastProps.visible}
                    message={toastProps.message}
                    type={toastProps.toastType}
                    onHiding={onToastHiding}
                    displayTime={600} />
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div >
    );

    function gradientSelectionChanged(e: any) {
        setDataLoaded(false);

        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            setSelectedGradient(e.selectedRowsData[0]);
        }
    }

    function onMethodValueChanged(e: any) {
        if (!dataLoaded)
            return;

        const caller = e.element.id as string;

        if (caller && methodDetail && methodDetail.methodId) {
            const m = methodDetail as any;
            const currentValue = m[caller];

            if (currentValue === e.value)
                return;
            else if (!currentValue && !e.value)
                return;
            else {
                let fieldUpdate: FieldUpdate = {
                    field: caller,
                    value: e.value,
                    rowId: methodDetail.methodId
                };

                updateMethodField(fieldUpdate)
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Method Field");
                    })
            }

            setMethodDetail({ ...methodDetail, [caller]: e.value });
        }
    }

    async function onValueChanged(e: any) {
        if (!dataLoaded)
            return;

        const caller = e.element.id as string;

        if (caller && methodDetail) {
            const m = methodDetail as any;
            const currentValue = m[caller];

            if (currentValue === e.value)
                return;
            else if (!currentValue && !e.value)
                return;
            else {
                let fieldUpdate: FieldUpdate = {
                    field: caller,
                    value: e.value,
                    rowId: methodDetail.methodId
                };

                await updateMethodDetailField(fieldUpdate)
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Method Detail Field");
                    })
            }
        }

        setMethodDetail({ ...methodDetail, [caller]: e.value });
    }

    function onAddGradientClick(e: any) {

    }

    async function onGradientsValidating(e: any) {
        if (!dataLoaded)
            return;

        if (e.oldData) {
            let gradient = e.oldData as Gradient;

            if (gradient) {
                let updatedGradient = { ...gradient, ...e.newData };

                updateGradient(updatedGradient)
                    .then(() => {
                        showToast("Gradient updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Gradient");
                    });
            }
        }
        else {
            if (e.newData) {
                let gradient = e.newData as Gradient;

                if (props.methodId) {
                    gradient.methodId = props.methodId;

                    await insertGradient(gradient)
                        .then(() => {
                            showToast("Gradient saved", "success");
                        })
                        .catch((res) => {
                            showMessage(res, ModalMessageType.Error, "Error Inserting Gradient");
                        });
                }
            }
        }
    }

    function onGradientsRowRemoving(e: any) {

    }

    function onGradientsRowRemoveClick(e: any) {

    }

    function onSolventsLookupApplySelection(solvent: SolventConfiguration) {

        //todo - save to database


        if (solvent && solvent.macolaSolvent) {
            let editedMethodDetail = { ...methodDetail };

            editedMethodDetail.solventName = solvent.macolaSolvent;

            setMethodDetail(editedMethodDetail);
            hideSolventsLookupDialog();
        }
        else {
            //show info dialog - "No solvent found"

        }
    }

    async function getMethodDetails() {
        if (props.methodId) {
            setDataLoaded(false);

            await CrudFunctions.getData(`methods/methoddetail/${props.methodId}`)
                .then(data => {

                    console.log("HPLC method details...");
                    console.log(data);


                    setMethodDetail(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Method Details");
                });
        }
    }

    async function getScanTypes() {
        await CrudFunctions.getData("common/scantypes")
            .then((data) => {
                setScanTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Scan Types");
            });
    }

    async function insertMethod(method: Method) {
        return await CrudFunctions.postData("methods/method", method);
    }

    async function insertGradient(gradient: Gradient) {
        return await CrudFunctions.postData("methods/gradient", gradient);
    }

    async function updateMethodField(fieldUpdate: FieldUpdate) {
        return await CrudFunctions.putData("methods/methodfield", fieldUpdate);
    }

    async function updateMethodDetailField(fieldUpdate: FieldUpdate) {
        return await CrudFunctions.putData("methods/methoddetailfield", fieldUpdate);
    }

    async function updateGradient(gradient: Gradient) {
        return await CrudFunctions.putData("methods/gradient", gradient);
    }

    async function deleteGradient(gradientId: string) {
        return await CrudFunctions.deleteData(`methods/gradient/${gradientId}`);
    }

    async function getAllData() {
        await getScanTypes()
            .then(() => { setDataLoaded(true) });
    }

    function onGradientsInfoButtonClick(e: any) {
        if (e.row && e.row.data) {
            const gradient = e.row.data as Gradient;

            if (gradient) {
                setSelectedGradient(gradient);

                let itemInformation: ItemBasicInformation = {
                    rowPointer: gradient.gradientId,
                    createTimestamp: gradient.createTimestamp,
                    lastModifiedTimestamp: gradient.modifyTimestamp,
                    createUser: gradient.createUser,
                    modifyUser: gradient.modifyUser
                };

                setItemBasicInformation(itemInformation);
                setItemBasicInformationDialogVisible(true);
            }
        }
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    function showSolventsLookupDialog() {
        setSolventLookupVisible(true);
    }

    function hideSolventsLookupDialog() {
        setSolventLookupVisible(false);
    }

    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}